export const mainTitle = {
  marginBottom: 24,
};

export const secondTitle = {
  marginTop: 36,
};
